import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';

import AttachmentSizeErrorBannerContainer from '../containers/AttachmentSizeErrorBannerContainer';
import appEnums from 'enums/app';
import configSelectors from 'selectors/configuration';
import ConnectionErrorBannerContainer from 'presentation/containers/ConnectionErrorBannerContainer';
import {
  getAttachmentsEnabled,
  getAuthError,
  getChatClientConnectionStatus,
  getCustomText,
  getServerError,
} from 'app/modules';
import { ERRORS } from 'enums/ui';
import ERROR_BANNER_ANIMATION_TIME from 'enums/ui';
import InputValidationCompositionContainer from 'presentation/selfService/containers/InputValidationCompositionContainer.js';
import uiSelectors from 'selectors/ui';
import userSelectors from 'selectors/user';
import useDelayedValueUpdate from 'presentation/hooks/delayedValueUpdate';

export function Footer(props) {
  Footer.propTypes = {
    attachmentError: PropTypes.string,
    canAddAttachments: PropTypes.bool,
    customText: PropTypes.object,
    currentCompositionStage: PropTypes.string,
    hasAuthError: PropTypes.bool.isRequired,
    hasServerError: PropTypes.bool,
    isChatClientConnected: PropTypes.bool.isRequired,
    isChatClientReconnecting: PropTypes.bool.isRequired,
  };

  function renderErrorBanner() {
    const hasAttachmentError = useDelayedValueUpdate(
      props.attachmentError === ERRORS.FILE_SIZE,
      ERROR_BANNER_ANIMATION_TIME
    );
    const hasConnectionError = useDelayedValueUpdate(!props.isChatClientConnected, ERROR_BANNER_ANIMATION_TIME);

    const hasAuthError = useDelayedValueUpdate(props.hasAuthError, ERROR_BANNER_ANIMATION_TIME);

    const hasServerError = useDelayedValueUpdate(props.hasServerError, ERROR_BANNER_ANIMATION_TIME);

    if (hasConnectionError || hasAuthError || hasServerError) {
      return (
        <ConnectionErrorBannerContainer
          animateIn={!props.isChatClientConnected || props.isChatClientReconnecting || hasAuthError || hasServerError}
          isChatClientConnected={props.isChatClientConnected}
          isChatClientReconnecting={props.isChatClientReconnecting}
        />
      );
    }
    if (hasAttachmentError) {
      return (
        <AttachmentSizeErrorBannerContainer
          animateIn={props.attachmentError === ERRORS.FILE_SIZE}
          isChatClientConnected={props.isChatClientConnected}
          isChatClientReconnecting={props.isChatClientReconnecting}
        />
      );
    }
  }

  return (
    <React.Fragment>
      {renderErrorBanner()}
      <InputValidationCompositionContainer
        canAddAttachments={props.canAddAttachments}
        customText={props.customText}
        currentCompositionStage={props.currentCompositionStage}
        isChatClientConnected={props.isChatClientConnected}
        isOnboardingEnabled={props.isOnboardingEnabled}
      />
    </React.Fragment>
  );
}

export const mapStateToProps = (state, props) => {
  const chatClientConnectionStatus = getChatClientConnectionStatus(state);
  const { CONNECTED, RECONNECTING } = appEnums.chatClientConnectionStatuses;

  return {
    ...props,
    attachmentError: uiSelectors.getAttachmentError(state.ui),
    canAddAttachments: !!(getAttachmentsEnabled(state) && userSelectors.getHasUserOnboarded(state.user)),
    customText: getCustomText(state),
    currentCompositionStage: uiSelectors.getCompositionStage(state.ui),
    hasAuthError: getAuthError(state) != null,
    hasServerError: getServerError(state) != null,
    isChatClientConnected: !chatClientConnectionStatus || chatClientConnectionStatus === CONNECTED,
    isChatClientReconnecting: chatClientConnectionStatus === RECONNECTING,
    isOnboardingEnabled: configSelectors.getOnboardingEnabled(state.configuration),
  };
};

const FooterContainer = connect(mapStateToProps)(Footer);

export default FooterContainer;
